import app from './app';
import slick from './slick';
import modal from './modal';
import homepageMap from './homepage-map';

export default {
  app,
  modal,
  homepageMap,
  slick
};



// WEBPACK FOOTER //
// ./resources/components/store/modules/index.js